var _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    enableBackground: "new 0 0 24 32",
    overflow: "visible",
    viewBox: "0 0 24 32",
    id: "excel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2cce7c",
    points: "0 0 0 32 16 32 24 24 24 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0ba55f",
    points: "16 24 16 32 24 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#08c462",
    points: "16 32 16 24 8 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M7.9 11.6c.4.6.6.9.8 1.2h0c.2-.3.5-.7.8-1.2l1.1-1.6h1.7l-2.7 3.9 2.8 4h-1.6l-1.2-1.8c-.3-.4-.6-.8-.8-1.2h0c-.3.4-.5.8-.8 1.2l-1.2 1.8H5l2.8-4L5.1 10h1.7L7.9 11.6zM15.3 10v6.6H19v1.2h-5.1V10H15.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.e15c7ff2d429b51d9c3a455442353dce.svg";
export { ForwardRef as ReactComponent };